import { TypeEventCodeEnum } from './TypeEventCodeEnum';

export class TypeEvent {
  constructor(public readonly id: number, public readonly code: TypeEventCodeEnum) {}
}
